import React, {use, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupPlaylists } from '../../actions/PlaylistActions'
import { useParams } from 'react-router-dom'
import arrowLeft from '../icons/Arrow_left.svg'
import { useNavigate, useNavigationType } from 'react-router-dom';
import { formatSeconds } from '../../utils/formatTime';


const GroupPage = () => {

    const {group_id, group_title} = useParams()

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const groupPageRef = useRef(null);

    const playlistList = useSelector(state => state.groupPlaylists)

    const navigationType = useNavigationType();
  
    const { loading, groupPlaylists} = playlistList
  
    useEffect(()=>{
        dispatch(getGroupPlaylists(group_id))
        localStorage.setItem("path", `/group/${group_id}/${group_title}`)
        window.scrollTo(0, 0)
    },[dispatch, group_id])

    useEffect(()=>{
        if(groupPlaylists && groupPlaylists.length && navigationType === "POP"){    
            groupPageRef.current.scrollTo({
                top: sessionStorage.getItem("results-scroll") || 0,
                behavior: "auto"
            })
        }
    },[groupPlaylists])


    const handleScroll = event => {

        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        sessionStorage.setItem("results-scroll", scrollTop);

      }    

    
    const onPlaylistClick = (playlist) => { 
        localStorage.setItem('video_id', playlist.video_id)
        localStorage.setItem('playlist_id', playlist.id)
        localStorage.setItem('group_id', group_id)
        navigate(`/home?v=${playlist.video_id}&p=${playlist.id}&g=${group_id}`)
    }
    
    return (
        <>
            <div className = "w-100 bg-bluedark d-flex flex-column align-items-center page-bg-fill">
                <div className = "w-100 d-flex flex-column align-items-center"
                    style={{maxHeight:"calc(100vh - 5rem)"}}
                >
                { 
                    loading ? <div className = "text-info col-12 col-lg-10" >Loading...</div> :
                    <>
                        <div className = 'w-100 pt-3 pt-md-5 pb-2 d-flex justify-content-center'>
                            <div className = "col-12 col-lg-10 d-flex flex-column flex-md-row justify-content-center align-items-start">
                                <div className = 'col-12 col-md-6 px-3 px-md-5 d-flex align-items-center justify-content-start'>
                                    <img
                                        src = {arrowLeft}
                                        role = 'button'
                                        onClick={()=>navigate(-1)}
                                        alt = ''
                                        className='flex-shrink-0'
                                        style={{height:"17px", width:"auto"}}
                                        />
                                    <div className='ps-3 text-white fs-7 page-title text-truncate flex-grow-1'
                                        style={{minWidth:0}}
                                        title={group_title}
                                    >{group_title}</div>
                                </div>
                                <div className='col-12 col-md-6 d-flex px-2 px-md-5 justify-content-end'>
                                    { groupPlaylists && groupPlaylists.length &&
                                        <>
                                            <div className='text-white text-nowrap pe-3' >{groupPlaylists.length} Playlists</div>
                                            <div className = "text-info px-3 border-start border-info text-nowrap">{groupPlaylists.reduce((sum, item)=>sum+item.stats.total_videos, 0)} Videos</div>
                                            <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(groupPlaylists.reduce((sum, item)=>sum+item.duration, 0))} </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                <div className='col-12 col-lg-10 px-4 d-flex flex-row flex-wrap results-wrapper'
                    ref={groupPageRef}
                    onScroll = {handleScroll}>
                            {
                                groupPlaylists && groupPlaylists.length ? 
                                groupPlaylists.map((playlist)=>(
                                    <div className='col-6 col-md-4 col-lg-3 p-1 p-md-3 rounded position-relative'>
                                        <img 
                                            src={`https://img.cugate.com/?o=CUTV_PLAYLIST&i=${playlist.id}&s=300`}
                                            alt=''
                                            className='rounded w-100'
                                            style={{aspectRatio:"16/9"}}
                                            role='button'
                                            onClick={() => onPlaylistClick(playlist)}
                                        />
                                        <div className='position-absolute p-1 p-md-3 text-white rounded bg-transparent'
                                            style={{zIndex:"300", bottom:"0", right:"0"}}>
                                                <div className='bg-dark p-1'
                                                >{formatSeconds(playlist.duration)}</div>
                                        </div>
                                    </div>
                                )) : ""
                            }
                        </div>
                    </>
                }
                </div>  
            </div>
        </>
    );
};

export default GroupPage;